// @ts-strict-ignore
import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { createBankAddressSchema } from 'utils/yupSchemas/addressSchemas'
import { createNameSchema, NAME_VALIDATION_PATTERN } from 'utils/yupSchemas/createNameSchema'

export const getBankAddressFields = (t: TFunction<'translation', undefined>) => {
  const bankName = createNameSchema(
    t('beneficiarysBankName'),
    t,
    null,
    null,
    NAME_VALIDATION_PATTERN,
    'manageBeneficiaries.nameFieldInvalidCharacters'
  )
  const bankAddressLine1 = createBankAddressSchema(t('bankAddressLine1'), t)
  const bankAddressLine2 = createBankAddressSchema(t('bankAddressLine2'), t)
  const bankCity = createBankAddressSchema(t('city'), t)
  const bankPostCode = createBankAddressSchema(t('postCode'), t)
  const bankRegion = createBankAddressSchema(t('region'), t)
  const bankCountry = yup.string().trim().label(t('country')).required()

  return {
    bankName,
    bankAddressLine1,
    bankAddressLine2,
    bankCity,
    bankPostCode,
    bankRegion,
    bankCountry,
  }
}
